import React, { ReactNode, useState } from 'react';
import styled from 'astroturf/react';
import { format, formatDistanceToNowStrict } from 'date-fns';

import { useBreakpoint } from 'js/design_system/hooks/useBreakpoint';
import { FollowableUser } from 'js/social/shared/types';
import { ImpressionPropsGenerator } from 'js/social/ImpressionHelper';
import { ImpressionWatcher, ImpressionEntity } from 'js/utils/impressions';
import { Body } from 'js/design_system/Body';
import { BodyLink } from 'js/design_system/link/BodyLink';
import AcademiaProfileIcon from '../Icons/academia-profile.svg';
import { Popover } from 'js/design_system/Popover';
import { Modal } from 'js/design_system/Modal';
import _AuthorWrapper from "AuthorHeader-AuthorWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/AuthorHeader.tsx?styleId=AuthorWrapper";
import _MultiAuthorWrapper from "AuthorHeader-MultiAuthorWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/AuthorHeader.tsx?styleId=MultiAuthorWrapper";
import _AuthorInfo from "AuthorHeader-AuthorInfo.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/AuthorHeader.tsx?styleId=AuthorInfo";
import _PostName from "AuthorHeader-PostName.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/AuthorHeader.tsx?styleId=PostName";
import _NormalBody from "AuthorHeader-NormalBody.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/AuthorHeader.tsx?styleId=NormalBody";
import _DenseBody from "AuthorHeader-DenseBody.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/AuthorHeader.tsx?styleId=DenseBody";
import _PostNameLink from "AuthorHeader-PostNameLink.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/AuthorHeader.tsx?styleId=PostNameLink";
import _Subtitle from "AuthorHeader-Subtitle.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/AuthorHeader.tsx?styleId=Subtitle";
import _AvatarWrapper from "AuthorHeader-AvatarWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/AuthorHeader.tsx?styleId=AvatarWrapper";
import _Avatar from "AuthorHeader-Avatar.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/AuthorHeader.tsx?styleId=Avatar";
import _AvatarLink from "AuthorHeader-AvatarLink.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/AuthorHeader.tsx?styleId=AvatarLink";
import _OverflowImpressionWatcher from "AuthorHeader-OverflowImpressionWatcher.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/AuthorHeader.tsx?styleId=OverflowImpressionWatcher";
import _Timestamp from "AuthorHeader-Timestamp.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/AuthorHeader.tsx?styleId=Timestamp";
import _MultiUserAvatarContainer from "AuthorHeader-MultiUserAvatarContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/AuthorHeader.tsx?styleId=MultiUserAvatarContainer";
import _MultiUserAvatarWrapper from "AuthorHeader-MultiUserAvatarWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/AuthorHeader.tsx?styleId=MultiUserAvatarWrapper";
import _MultiUserAvatarClip from "AuthorHeader-MultiUserAvatarClip.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/AuthorHeader.tsx?styleId=MultiUserAvatarClip";
import _MultiUserAvatarBorder from "AuthorHeader-MultiUserAvatarBorder.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/AuthorHeader.tsx?styleId=MultiUserAvatarBorder";
import _MultiUserAvatarCount from "AuthorHeader-MultiUserAvatarCount.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/AuthorHeader.tsx?styleId=MultiUserAvatarCount";
import _MultiUserPopoverScrollContainer from "AuthorHeader-MultiUserPopoverScrollContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/AuthorHeader.tsx?styleId=MultiUserPopoverScrollContainer";
import _MultiUserPopover from "AuthorHeader-MultiUserPopover.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/AuthorHeader.tsx?styleId=MultiUserPopover";
import _MultiUserTrigger from "AuthorHeader-MultiUserTrigger.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/AuthorHeader.tsx?styleId=MultiUserTrigger";


const AuthorWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "AuthorWrapper",
  styles: _AuthorWrapper
});

const MultiAuthorWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "MultiAuthorWrapper",
  styles: _MultiAuthorWrapper
});

const AuthorInfo = /*#__PURE__*/styled("div", null, {
  displayName: "AuthorInfo",
  styles: _AuthorInfo
});

const PostName = /*#__PURE__*/styled(Body, null, {
  displayName: "PostName",
  styles: _PostName
});

const NormalBody = /*#__PURE__*/styled(Body, null, {
  displayName: "NormalBody",
  styles: _NormalBody
});

const DenseBody = /*#__PURE__*/styled(Body, null, {
  displayName: "DenseBody",
  styles: _DenseBody
});

const PostNameLink = /*#__PURE__*/styled(BodyLink, null, {
  displayName: "PostNameLink",
  styles: _PostNameLink
});

const Subtitle = /*#__PURE__*/styled(Body, null, {
  displayName: "Subtitle",
  styles: _Subtitle
});

const AvatarWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "AvatarWrapper",
  styles: _AvatarWrapper
});

const Avatar = /*#__PURE__*/styled("img", null, {
  displayName: "Avatar",
  styles: _Avatar
});

const AvatarLink = /*#__PURE__*/styled("a", null, {
  displayName: "AvatarLink",
  styles: _AvatarLink
});

const OverflowImpressionWatcher = /*#__PURE__*/styled(ImpressionWatcher, null, {
  displayName: "OverflowImpressionWatcher",
  styles: _OverflowImpressionWatcher
});

const Timestamp = /*#__PURE__*/styled(Body, null, {
  displayName: "Timestamp",
  styles: _Timestamp
});

type UserImageProps = {
  kind: 'user';
  user: FollowableUser;
};

type RecommendationImageProps = {
  kind: 'recommendation';
};

type SharedImageProps = {
  // These coorespond to the following non-mobile avatar sizes:
  //     32     40     48     56
  size: 'xs' | 'sm' | 'md' | 'lg';
};

type ImageProps = SharedImageProps &
  (UserImageProps | RecommendationImageProps);

export const AuthorAvatar = ({ size, ...restProps }: ImageProps) => {
  const breakpoint = useBreakpoint();
  let avatarSize;
  switch (size) {
    case 'xs':
      avatarSize = breakpoint === 'small' ? 24 : 32;
      break;
    case 'sm':
      avatarSize = breakpoint === 'small' ? 32 : 40;
      break;
    case 'md':
      avatarSize = breakpoint === 'small' ? 40 : 48;
      break;
    case 'lg':
      // Note: no examples of lg + small breakpoint exist, 48px is a guess
      avatarSize = breakpoint === 'small' ? 48 : 56;
      break;
  }

  if (restProps.kind === 'user') {
    return (
      <AvatarLink href={restProps.user.url}>
        <Avatar
          style={{ width: avatarSize, height: avatarSize }}
          src={restProps.user.photo}
        />
      </AvatarLink>
    );
  } else if (restProps.kind === 'recommendation') {
    return (
      <AvatarWrapper>
        <AcademiaProfileIcon size={avatarSize} />
      </AvatarWrapper>
    );
  } else {
    return null;
  }
};

const MultiUserAvatarContainer = /*#__PURE__*/styled("div", null, {
  displayName: "MultiUserAvatarContainer",
  styles: _MultiUserAvatarContainer
});

const MultiUserAvatarWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "MultiUserAvatarWrapper",
  styles: _MultiUserAvatarWrapper
});

const MultiUserAvatarClip = /*#__PURE__*/styled("div", null, {
  displayName: "MultiUserAvatarClip",
  styles: _MultiUserAvatarClip
});

const MultiUserAvatarBorder = /*#__PURE__*/styled("div", null, {
  displayName: "MultiUserAvatarBorder",
  styles: _MultiUserAvatarBorder
});

const MultiUserAvatarCount = /*#__PURE__*/styled(Body, null, {
  displayName: "MultiUserAvatarCount",
  styles: _MultiUserAvatarCount
});

const MultiUserAvatar = ({
  users,
  size,
}: SharedImageProps & { users: FollowableUser[] }) => {
  if (users.length === 1) {
    return <AuthorAvatar kind="user" user={users[0]} size={size} />;
  }

  const extraCount = users.length - 3;

  return (
    <>
      <MultiUserAvatarContainer>
        {users.slice(0, 3).map((user, i) => (
          <MultiUserAvatarWrapper key={user.id}>
            <MultiUserAvatarClip>
              <AuthorAvatar kind="user" user={user} size={size} />
            </MultiUserAvatarClip>
            {i === 2 && extraCount > 0 && (
              <MultiUserAvatarCount bold size="md">
                +{extraCount}
              </MultiUserAvatarCount>
            )}
            <MultiUserAvatarBorder />
          </MultiUserAvatarWrapper>
        ))}
      </MultiUserAvatarContainer>
    </>
  );
};

const MultiUserPopoverScrollContainer = /*#__PURE__*/styled("div", null, {
  displayName: "MultiUserPopoverScrollContainer",
  styles: _MultiUserPopoverScrollContainer
});

const MultiUserPopover = /*#__PURE__*/styled("div", null, {
  displayName: "MultiUserPopover",
  styles: _MultiUserPopover
});

const MultiUserTrigger = /*#__PURE__*/styled("div", null, {
  displayName: "MultiUserTrigger",
  styles: _MultiUserTrigger
});

const MultiUserTitle = ({
  users,
  userTitle,
  groupName,
  action,
  paperType,
  size,
  className,
  variant = 'default',
}: MultiUserProps &
  SharedImageProps & { className?: string; variant?: 'default' | 'dense' }) => {
  const groupNameText = groupName ? ` in ${groupName}` : '';
  const paperNameText = paperType === 'paper' ? 'a paper' : 'a trending paper';
  const verbText = action === 'save' ? 'saved' : 'viewed';
  const fontSize = size === 'xs' || variant === 'dense' ? 'md' : 'lg';
  const BodyComponent = variant === 'dense' ? DenseBody : NormalBody;

  const renderUserTitle = (displayName: string, title: string) => (
    <BodyComponent
      size={fontSize}
      className={className}
      bold={variant === 'dense'}
    >
      {variant === 'default' ? (
        <>
          <Body as="strong" size={fontSize} bold>
            {displayName}, {title}
          </Body>
          {groupNameText}, {verbText} {paperNameText}
        </>
      ) : (
        <>
          {displayName}, {title}
          {groupNameText}, {verbText} {paperNameText}
        </>
      )}
    </BodyComponent>
  );

  const renderMultiUserTitle = (count: number, title: string) => (
    <BodyComponent
      size={fontSize}
      className={className}
      bold={variant === 'dense'}
    >
      {variant === 'default' ? (
        <>
          <Body as="strong" size={fontSize} bold>
            {count} {title}
          </Body>
          {groupNameText} {verbText} {paperNameText}
        </>
      ) : (
        <>
          {count} {title}
          {groupNameText} {verbText} {paperNameText}
        </>
      )}
    </BodyComponent>
  );

  if (
    !userTitle ||
    (userTitle !== 'published' && userTitle !== 'highly-cited')
  ) {
    return null;
  }

  const title =
    userTitle === 'published'
      ? 'published researcher'
      : 'highly-cited researcher';
  const titles = `${title}s`;

  return users.length === 1
    ? renderUserTitle(users[0].displayName, title)
    : renderMultiUserTitle(users.length, titles);
};

const MultiAuthorWrapperWithInteraction = ({
  avatarInteractionContents,
  children,
}: {
  avatarInteractionContents?: ReactNode;
  children: ReactNode;
}) => {
  const [showInteractionModal, setShowInteractionModal] = useState(false);
  const breakpoint = useBreakpoint();

  if (!avatarInteractionContents) {
    return <>{children}</>;
  }

  if (breakpoint === 'small') {
    return (
      <>
        <MultiUserTrigger onClick={() => setShowInteractionModal(true)}>
          {children}
        </MultiUserTrigger>
        <Modal
          open={showInteractionModal}
          onClose={() => setShowInteractionModal(false)}
        >
          {avatarInteractionContents}
        </Modal>
      </>
    );
  } else {
    return (
      <Popover
        render={() => (
          <MultiUserPopover>
            <MultiUserPopoverScrollContainer>
              {avatarInteractionContents}
            </MultiUserPopoverScrollContainer>
          </MultiUserPopover>
        )}
        maxWidth={480}
        maxHeight={200}
        placement="top-start"
        offset={17}
      >
        <MultiUserTrigger>{children}</MultiUserTrigger>
      </Popover>
    );
  }
};

type UserProps = {
  kind: 'user';
  user: FollowableUser;
  link?: boolean;
  timestamp?: string;
  showTimestamp: boolean;
  extraSubtitles?: string[];
};

type MultiUserProps = {
  kind: 'multi-user';
  users: FollowableUser[];
  userTitle: 'published' | 'highly-cited';
  groupName?: string;
  action: 'save' | 'view';
  paperType: 'paper' | 'trending';
  avatarInteractionContents?: ReactNode;
};

type RecommendationProps = {
  kind: 'recommendation';
  recommendation: {
    name: string;
    subtitle?: string;
  };
};

type SharedProps = {
  impressionPropsGen: ImpressionPropsGenerator;
  showAvatar: boolean;
  className?: string;
} & SharedImageProps;

type Props = SharedProps &
  (UserProps | MultiUserProps | RecommendationProps) & {
    variant?: 'default' | 'dense';
  };

// This component should be used to render any instance of a "post author", such
// as in the header of a news feed unit or a comment author. It consists of a
// name, some optional subtitles, and an optional avatar.
//  ________
// /        \   Title
// | avatar |   Subtitle
// \        /   (timestamp)
//  --------
//
// The 'kind' prop determines what kind of data should be used to generate the
// header. It can be a 'user' for a human author, 'recommendation' for an
// academia-generated piece of content, or 'multi-user' for posts which
// reference multiple authors.
//
// The 'size' prop determines how large the avatar and fonts should be. See
// `SharedImageProps` above to determine which size to use.
//
// If rendering the avatar and text separately, pass `showAvatar={false}` and
// render the avatar with the same size using `AuthorAvatar`.
export const AuthorHeader = ({
  impressionPropsGen,
  showAvatar,
  size,
  className,
  variant = 'default',
  ...restProps
}: Props) => {
  if (restProps.kind === 'user') {
    const {
      kind,
      user,
      link = true,
      timestamp,
      showTimestamp,
      extraSubtitles,
    } = restProps;

    const body = (
      <AuthorInfo className={showAvatar ? undefined : className}>
        <OverflowImpressionWatcher
          {...impressionPropsGen(ImpressionEntity.User, user.id)('prof-n')()}
        >
          {link ? (
            <PostNameLink
              size={size === 'xs' ? 'sm' : 'md'}
              bold
              href={user.url}
            >
              {user.displayName}
            </PostNameLink>
          ) : (
            <PostName size={size === 'xs' ? 'sm' : 'md'} bold>
              {user.displayName}
            </PostName>
          )}
        </OverflowImpressionWatcher>
        {user.university && (
          <Subtitle size={size === 'xs' ? 'xs' : 'sm'}>
            {[
              user.position,
              user.university?.displayName,
              user.department?.displayName,
            ]
              .filter(Boolean)
              .join(', ')}
          </Subtitle>
        )}
        {showTimestamp && timestamp && (
          <time dateTime={timestamp} title={format(new Date(timestamp), 'PPP')}>
            <Timestamp size={size === 'xs' ? 'xs' : 'sm'}>
              {formatDistanceToNowStrict(new Date(timestamp))}
            </Timestamp>
          </time>
        )}
        {extraSubtitles &&
          extraSubtitles.map((subtitle, i) => (
            <Subtitle key={i} size={size === 'xs' ? 'xs' : 'sm'}>
              {subtitle}
            </Subtitle>
          ))}
      </AuthorInfo>
    );

    if (showAvatar) {
      return (
        <AuthorWrapper size={size} className={className} variant={variant}>
          <AuthorAvatar kind={kind} user={user} size={size} />
          {body}
        </AuthorWrapper>
      );
    } else {
      return body;
    }
  } else if (restProps.kind === 'multi-user') {
    const {
      kind,
      users,
      userTitle,
      groupName,
      action,
      paperType,
      avatarInteractionContents,
    } = restProps;

    const body = (
      <MultiUserTitle
        className={showAvatar ? undefined : className}
        kind={kind}
        users={users}
        userTitle={userTitle}
        groupName={groupName}
        action={action}
        paperType={paperType}
        size={size}
        variant={variant}
      />
    );

    if (showAvatar) {
      return (
        <MultiAuthorWrapper
          size={size}
          className={className}
          variant={variant}
          single={users.length === 1}
        >
          <MultiAuthorWrapperWithInteraction
            avatarInteractionContents={avatarInteractionContents}
          >
            <MultiUserAvatar users={users} size={size} />
          </MultiAuthorWrapperWithInteraction>
          {body}
        </MultiAuthorWrapper>
      );
    } else {
      return (
        <MultiAuthorWrapperWithInteraction
          avatarInteractionContents={avatarInteractionContents}
        >
          {body}
        </MultiAuthorWrapperWithInteraction>
      );
    }
  } else if (restProps.kind === 'recommendation') {
    const { kind, recommendation } = restProps;
    const body = (
      <AuthorInfo className={showAvatar ? undefined : className}>
        <PostName size={size === 'xs' ? 'sm' : 'md'} bold variant={variant}>
          {recommendation.name}
        </PostName>
        {recommendation.subtitle && (
          <Subtitle size={size === 'xs' ? 'xs' : 'sm'}>
            {recommendation.subtitle}
          </Subtitle>
        )}
      </AuthorInfo>
    );

    if (showAvatar) {
      return (
        <AuthorWrapper size={size} className={className} variant={variant}>
          <AuthorAvatar kind={kind} size={size} />
          {body}
        </AuthorWrapper>
      );
    } else {
      return body;
    }
  } else {
    return null;
  }
};
